/**
 * Authentication service from IP
 * extends AuthService
 **/

//Core
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
// Services
import { AuthService } from 'libraries/service/auth/auth.service';
import { HttpHeaders } from '@angular/common/http';

@Injectable()
export class AuthLocobookService extends AuthService {

    // Set url to avoid default redirection
    public url: string = 'locobook';

    /**
     * overwrite getXsecurity, from IP and not ID/PWD
     */
    public getXsecurity(): Observable<any> | string {

        //Get client IP
        const json = {
            "ip": sessionStorage.getItem('$ip')
        };

        const body = JSON.stringify(json);

        // ... Set content type to JSON
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

        // Create a request option
        const options = { headers };

        // Send and get response
        this.http
            .post(this.xsecurityPath, body, options)
            .subscribe(
                (res: any) => {
                    this.getToken(res);
                },
                (error: any): any => {
                    this.handleError(error);
                }
            );
        // §TR_#15699 => Types of property 'getXsecurity' are incompatible.
        // the original getXsecurity from the parent doesn't correpond
        // @see => ../../app/auth/auth.service;
        return '';
    }

}
